import { useEffect } from 'react';
import { useAuthStore } from '../../../../../auth/shared/store/useAuthStore';
import { useTokenizedCardsStore } from '../../payment/helpers/useTokenizedCardsStore';
import { ParkingPageId } from '../../../../domain/pages/ParkingPageId';
import { usePrefetchEffect } from '../../../../../shared/router/usePrefetchEffect';
import { useUrlForPageId } from '../../../../../app/pages/ui/utils/useUrlForPageId';

export function usePrefetchPaymentUrl() {
	const url = useUrlForPageId(ParkingPageId.NewBookingPayment);
	usePrefetchEffect(url);

	const { isAuthenticated } = useAuthStore();
	const tokenizedCardsStore = useTokenizedCardsStore();

	useEffect(() => {
		if (isAuthenticated) {
			tokenizedCardsStore.load();
		}
	}, [tokenizedCardsStore, isAuthenticated]);

	return { url };
}
